<template>
  <div>
<NavBar></NavBar>
    <div class="z-40 mt-10 pt-2 pb-3 block h-32 bg-white w-full text-center">
  <DropdownMain class="relative z-40 w-full block lg:w-1/5  h-12 lg:inline-block align-top text-center"></DropdownMain>
  <DropdownSub  class="relative z-30 w-full block lg:w-1/5  h-12 lg:h-12 lg:inline-block align-top text-center" v-on-clickaway="away"></DropdownSub>
    <button @click="search($event)" style="padding-top:9px;padding-bottom:9px;" class="w-full lg:w-1/6 bg-black text-white rounded-none font-bold px-8 active:bg-gray-900 focus:outline-none">
  Search
</button>
        <p v-if="propertylist.length == 0" class="font-bold relative  font-size margin-auto relative z-10">  {{propertyListLength}} results </p>

</div>

      <div class="z-10">
  <div class="lg:mx-64 md:mx-32 p-2 mt-10 min-h-screen text-center" >
    <div v-if="loadingState == true" class="loader">Loading...</div>
    <div v-if="propertylist.length == 0 && loadingState == false ">

      <h2 class="font-medium">Recent Updates</h2>

      <div class="flex-wrap sm:flex">
<div v-bind:key="item.id" v-for="item in latestkitlist" class="lg:w-1/3 md:w-1/3 sm:w-1/3 mt-4" >
  <div class="px-6 py-4  bg-white rounded mr-4 overflow-hidden h-1/2 shadow-lg">
    <div class="font-bold text-xl mb-2">{{item.name}}</div>
    <div class="overflow-y-auto h-56">
    <p class="text-gray-700 text-base">
      {{item.desc}}
    </p>
      </div>

        <div class="py-4">
      <a target="_blank"  :href="item.pdfUrl">
    <button class="block bg-gray-200 float-right rounded-full px-3 py-1 text-sm font-semibold text-gray-700 ml-2">View Deal</button>
               </a>
      <a target="_blank"  :href="item.url">

    <button class="block bg-gray-200 float-right rounded-full px-3 py-1 text-sm font-semibold text-gray-700 ">Visit Developer</button>
               </a>

  </div>
  </div>

</div>
      </div>

      </div>
        <!-- {{kitlist}} -->

    <Card v-if="propertylist.length != 0 && loadingState == false">
    </Card>
  </div>

  </div>

       <Footer></Footer>
  </div>

</template>

<script>
import {
  mapState, mapGetters, mapMutations, mapActions,
} from 'vuex';
import _ from 'lodash';
import { mixin as clickaway } from 'vue-clickaway';
import DropdownSub from '../components/dropdown/DropdownSub.vue';
import DropdownMain from '../components/dropdown/DropdownMain.vue';
import NavBar from '../components/navigation/Navbar.vue';
import Footer from '../components/footer/Footer.vue';
import Card from '../components/list-card/Card.vue';

export default {
  components: {
    DropdownSub, NavBar, Footer, DropdownMain, Card,
  },

  head() {
    return {
      title: {
        inner: 'Home',
      },
      meta: [
        {
          name: 'description',
          content: `${this.appTitle} home page`,
          id: 'desc',
        },
      ],
    };
  },
  data() {
    return {
      isOpen: false,
      loading: false,
      signup: true,
      totalResults: 0,
      type: [
        { name: 'illness', selected: false },
        { name: 'contraceptive', selected: false },
        { name: 'other', selected: false },
      ],
      selectedType: 'allergies',
      selected: '',
      options: [
        { text: 'illness', value: 'illness' },
        { text: 'contraceptive', value: 'contraceptive' },
        { text: 'other', value: 'other' },
      ],
      restOfCities: [],
      openBox: false,
    };
  },
  mixins: [clickaway],
  computed: {
    ...mapState('search', ['dropdownMainSelected', 'mainCatSelected', 'subCatInfo', 'subCatSelected', 'latestkitlist', 'dropdownIndex', 'mainOptions', 'propertylist', 'MainOptionSelected', 'SelectedOption']),
    ...mapState('app', ['appTitle']),
    ...mapState('card', ['testkitproducts']),
    loadingState() {
      return this.loading;
    },
    propertyListLength: {
      get() {
        let results = 0;
        this.propertylist.forEach((element) => {
          results += Number(element.length);
        });
        return results;
      },
    },

  },
  methods: {
    ...mapActions('card', ['getTestKitProducts']),
    ...mapActions('search', ['getMainOptions', 'getSelectedSubcat', 'getTestKitProducts', 'getLatest']),
    ...mapGetters('search', ['getDropdown', 'getAmount']),
    ...mapMutations('search', ['setDropdownMainCatIndex', 'ResetFirstOption', 'SetMainCatagory', 'SetSubCatagoryDirectly', 'SetMainCatagoryDirectly']),
    populateCities(event) {
      console.log(this.$refs.input);
      // `this` inside methods point to the Vue instance
      // `event` is the native DOM event
      event.preventDefault();
      this.openBox = true;
      this.restOfCities = [
        { name: 'Montreal', selected: false },
        { name: 'Vancouver', selected: false },
        { name: 'Toronto', selected: false },
        { name: 'Calgary', selected: false },
      ];
      _.remove(this.restOfCities, this.selected);
    },
    setCity(name, event) {
      // `this` inside methods point to the Vue instance
      // `event` is the native DOM event
      event.preventDefault();
      this.selected = name;
      _.remove(this.restOfCities, { name, selected: false });
      this.restOfCities = [];
      this.openBox = false;
    },
    searchSub() {
      console.log(this.dropdownMainSelected);
    },
    setType(type, event) {
      event.preventDefault();
      this.selectedType = type.name;
    },
    loadSelect(name, index, event) {
      event.preventDefault();
      console.log('loading');
      console.log(name);
      this.setDropdownMainCatIndex({ index });
      this.SetMainCatagory();
      this.ResetFirstOption();
      this.selectedType = name;
    },
    search(event) {
      console.log('push');
      console.log(this.MainOptionSelected);
      event.preventDefault();
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 500);
      this.$router.replace({
        name: 'search',
        params: {
          categoryname: this.mainCatSelected.name, subcatagoryname: this.subCatSelected.name, categoryid: this.dropdownIndex, pagenum: 1,
        },
      });
      this.getTestKitProducts();
      this.getSelectedSubcat();
    },
    handleBlur() {
      this.restOfCities = this.selected;
    },
    away() {
      this.restOfCities = [];
    },
  },
  async mounted() {
    console.log('component mounted');
    await this.getLatest();

    await this.getMainOptions();
    if (this.$route.params.categoryname != null && this.$route.params.subcatagoryname != null) {
      console.log(this.$route.params.categoryid);
      console.log(this.$route.params.subcatagoryid);
      this.SetMainCatagoryDirectly({ option: this.$route.params.categoryname });
      this.SetSubCatagoryDirectly({ option: this.$route.params.subcatagoryname });
      this.setDropdownMainCatIndex({ index: this.$route.params.categoryid });
      this.getTestKitProducts();
      this.getSelectedSubcat();
      this.selectedType = this.$route.params.categoryname;
    }
    // const mainOptions = await this.mainOptions
    // console.log( mainOptions[this.dropdownIndex].options[0][0].id)
  },

};
</script>

<style lang="css">
@import '../../public/build/tailwind.css';
</style>
